import { render, staticRenderFns } from "./OracleSendOrderFailure.vue?vue&type=template&id=2f02ade8&scoped=true"
import script from "./OracleSendOrderFailure.vue?vue&type=script&lang=js"
export * from "./OracleSendOrderFailure.vue?vue&type=script&lang=js"
import style0 from "./OracleSendOrderFailure.vue?vue&type=style&index=0&id=2f02ade8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02ade8",
  null
  
)

export default component.exports